import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import styles from './CardLayout.module.less'

const Card = ({ children, className }) => {
  const classNames = cx({
    [styles.card]: true,
    [className]: !!className,
  })

  return <div className={classNames}>{children}</div>
}
Card.propTypes = {
  className: PropTypes.string,
}

const CardColumns = ({ children, className, isDual }) => {
  const classNames = cx({
    [styles.columns]: true,
    [styles.columnsDual]: isDual,
    [className]: !!className,
  })

  return <div className={classNames}>{children}</div>
}
CardColumns.propTypes = {
  className: PropTypes.string,
}

const CardColumn = ({ children, className }) => {
  const classNames = cx({
    [styles.column]: true,
    [className]: !!className,
  })

  return <div className={classNames}>{children}</div>
}
CardColumn.propTypes = {
  className: PropTypes.string,
}

export { Card, CardColumns, CardColumn }
